import React from 'react';
import diversescreen from '../../../assets/images/home/embrace-screen.png';
import dancingshark from '../../../assets/images/home/dancingshark.gif';

const Embrace = () => {
    return (
        <>

            {/* <div className='embrace-section section-pading custom-color-014598'>
                <div className='container'>
                    <div className='row align-items-center embrace-section-row'>
                        <div className='col-lg-6 col-md-12 text-center mt-4'>
                            <div data-aos="fade-down">
                                <img className='screenMaxWidth' src={embracescreen} alt="Embrace Screen" />
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-12'>
                            <div data-aos="fade-up">
                                <h1 className='text-white h1-regular'>Learn the Skillz that Matter</h1>
                                <hr className='under-line-custom-hr bg-secondary' />
                                <p className='text-white text-wrap'>Z and his family will walk you through short lessons with follow up questions, watch you unlock
                                quests and encourage you to compete against other users. Gain the SharkSkillz you need.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className='diverse-section section-pading custom-color-014598'>
                <div className='container'>
                    <div className='row align-items-center diverse-row justify-content-center'>
                        <div className='col-lg-6 col-md-12'>
                            <div data-aos="fade-down">
                                <h1 className='text-white h1-regular'>Stay Focused</h1>
                                <hr className='under-line-custom-hr bg-secondary' />
                                <p className='text-white text-wrap'>Earn SharkCoins, Badges and keep up your daily streak as you journey through our App. Will you
                                be the biggest shark in the ocean?</p>
                                <img className='logo-width' src={dancingshark} alt="Logo" />
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-12 text-center'>
                            <div data-aos="fade-up">
                                <img className='screenMaxWidth' src={diversescreen} alt="Diverse Screen" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Embrace
